import { Link } from 'react-router-dom';

export default function CFIsCTA() {
  return (
    <section className="py-32 px-6 bg-gradient-to-b from-[#0D1B33] to-[#0A1628] relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/98b77235fed66e96203db0fae984717c.jpg')] opacity-5 bg-cover bg-center"></div>
      
      <div className="absolute top-20 left-10 w-72 h-72 bg-emerald-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-teal-500/10 rounded-full blur-3xl"></div>

      <div className="max-w-5xl mx-auto text-center relative z-10">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-500/10 border border-emerald-500/20 rounded-full mb-8">
          <i className="ri-rocket-fill text-emerald-400 text-lg"></i>
          <span className="text-emerald-400 font-medium text-sm">Ready to Transform Your Instruction?</span>
        </div>

        <h2 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
          Start Teaching Smarter,
          <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-400">
            Not Harder
          </span>
        </h2>

        <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed">
          Join the growing community of flight instructors using WingmanFix to deliver better training outcomes and accelerate student success
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <Link
            to="/waitlist"
            className="w-full sm:w-auto px-10 py-5 bg-emerald-500 hover:bg-emerald-600 text-white font-bold text-lg rounded-xl transition-all duration-300 hover:shadow-2xl hover:shadow-emerald-500/40 hover:scale-105 flex items-center justify-center gap-3 whitespace-nowrap"
          >
            <i className="ri-flight-takeoff-fill text-2xl"></i>
            Start Free Trial
          </Link>
          <Link
            to="/waitlist"
            className="w-full sm:w-auto px-10 py-5 bg-white/5 hover:bg-white/10 text-white font-bold text-lg rounded-xl border border-gray-600 hover:border-emerald-500/50 transition-all duration-300 flex items-center justify-center gap-3 whitespace-nowrap"
          >
            Join Waitlist
            <i className="ri-arrow-right-line text-2xl"></i>
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="flex flex-col items-center gap-3">
            <div className="w-16 h-16 rounded-2xl bg-emerald-500/10 border border-emerald-500/20 flex items-center justify-center">
              <i className="ri-time-line text-emerald-400 text-3xl"></i>
            </div>
            <div>
              <p className="text-3xl font-bold text-white mb-1">30 Days</p>
              <p className="text-gray-400 text-sm">Free trial period</p>
            </div>
          </div>

          <div className="flex flex-col items-center gap-3">
            <div className="w-16 h-16 rounded-2xl bg-teal-500/10 border border-teal-500/20 flex items-center justify-center">
              <i className="ri-user-follow-line text-teal-400 text-3xl"></i>
            </div>
            <div>
              <p className="text-3xl font-bold text-white mb-1">340+</p>
              <p className="text-gray-400 text-sm">CFIs on waitlist</p>
            </div>
          </div>

          <div className="flex flex-col items-center gap-3">
            <div className="w-16 h-16 rounded-2xl bg-blue-500/10 border border-blue-500/20 flex items-center justify-center">
              <i className="ri-shield-check-line text-blue-400 text-3xl"></i>
            </div>
            <div>
              <p className="text-3xl font-bold text-white mb-1">No Risk</p>
              <p className="text-gray-400 text-sm">Cancel anytime</p>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-12 border-t border-gray-700/50">
          <p className="text-gray-400 text-sm mb-4">
            Questions about CFI features or school pricing?
          </p>
          <a
            href="mailto:instructors@wingmanfix.com"
            className="inline-flex items-center gap-2 text-emerald-400 hover:text-emerald-300 font-medium transition-colors whitespace-nowrap"
          >
            <i className="ri-mail-line text-lg"></i>
            instructors@wingmanfix.com
          </a>
        </div>
      </div>
    </section>
  );
}